// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__XeJKw","header":"PatientQuestionnaire_header__3JpjU","info":"PatientQuestionnaire_info__38OKH"};